var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`async-image ${!_vm.isLoaded ? 'image-loading' : ''}`},[_c('img',{attrs:{"src":_vm.src},on:{"load":_vm.loaded}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-loader-container"},[_c('div',{staticClass:"image-loader"})])
}]

export { render, staticRenderFns }